import { GrowthDashboardTopBarActions, MapPackIntelligenceView } from '@elva/ui';
import { AsyncBoundary } from '@/components/feedback';
import { usePageTopBar } from '@/app/layouts/pageTopBar';
import { viewProps } from '@/data/viewProps';
import { useMapPack } from '@/features/map-pack/hooks/useMapPack';

export function GbpPage() {
  usePageTopBar({
    actions: <GrowthDashboardTopBarActions />,
  });

  const { data, isPending, isError, error, refetch, isRefetching, isFetching } = useMapPack();

  return (
    <AsyncBoundary
      loading={isPending}
      error={data === undefined && isError ? error : undefined}
      onRetry={refetch}
      retrying={isRefetching}
    >
      <MapPackIntelligenceView {...viewProps({ data, loading: isFetching })} />
    </AsyncBoundary>
  );
}
